import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect } from "react-redux";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import RelatedProductSlider from "../../wrappers/product/RelatedProductSlider";
import ProductDescriptionTab from "../../wrappers/product/ProductDescriptionTab";
import ProductImageDescriptionSticky from "../../wrappers/product/ProductImageDescriptionSticky";

const ProductSticky = ({ location, product }) => {
  const { pathname } = location;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (product != null) {
      setLoading(false);
    }
  }, [product]);

  return (
    <Fragment>
      <MetaTags>
        <title>Minyatür Sepeti | {product && product.name}</title>
        <meta name="description" content="Product page of Minyatür Sepeti." />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>
        ANASAYFA
      </BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        {product && product.name}
      </BreadcrumbsItem>

      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb />

        {loading ? (
          <div
            style={{ textAlign: "center", height: "500px", marginTop: "2%" }}
          >
            <img
              src="/assets/img/loadingNew.gif"
              style={{ width: "100px", marginBottom: "3%" }}
              alt="Ürün yükleniyor..."
            />
            <br />
            <span className="loading-text">
              Ürün bilgileri yüklenirken lütfen bekleyiniz...
            </span>
          </div>
        ) : (
          <div>
            {/* product description with image */}
            <ProductImageDescriptionSticky
              spaceTopClass="mt-100"
              spaceBottomClass="mb-100"
              product={product}
            />

            {/* product description tab */}
            <ProductDescriptionTab spaceBottomClass="pb-90" product={product} />

            {/* related product slider */}
            {/* <RelatedProductSlider
              spaceBottomClass="pb-95"
              category={product.category.name}
            /> */}
          </div>
        )}
      </LayoutOne>
    </Fragment>
  );
};

ProductSticky.propTypes = {
  location: PropTypes.object,
  product: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const itemId = ownProps.match.params.id;
  return {
    product: state.productData.products.filter(
      (single) => single.id === itemId
    )[0],
  };
};

export default connect(mapStateToProps)(ProductSticky);
